import { render, staticRenderFns } from "./uploadpic.vue?vue&type=template&id=132b7d8e&scoped=true&"
import script from "./uploadpic.vue?vue&type=script&lang=js&"
export * from "./uploadpic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132b7d8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\english\\new-evaluation\\src\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('132b7d8e')) {
      api.createRecord('132b7d8e', component.options)
    } else {
      api.reload('132b7d8e', component.options)
    }
    module.hot.accept("./uploadpic.vue?vue&type=template&id=132b7d8e&scoped=true&", function () {
      api.rerender('132b7d8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/uploadpic/uploadpic.vue"
export default component.exports